import { IController } from 'angular';
import * as _ from 'lodash';
import { GraduationPlan } from './../../../../../../../../ng2/shared/constants/graduation-plan.constant';
import { WizardUtils } from './../../../../../../../shared/services/wizard-utils/wizard-utils.service';

export class GradPlanningStepCtrl implements IController {
  static $inject: string[] = ['$scope', 'ObjectCache', 'WizardUtils'];

  public filteredStudents;
  public sort: string;
  public plannedInPastOrIncomplete;

  // bindings
  public selectedGradDate: string | null;

  constructor(public $scope, private ObjectCache, private WizardUtils: WizardUtils) {}

  $onInit(): void {
    this.WizardUtils.startListeningAndLoad(this);
  }

  setUi(): void {
    this.filteredStudents = this.WizardUtils.getFilteredFlattenedStudents();
    this.plannedInPastOrIncomplete = this.getStudentIdsByGradPlan();
    this.sort = this.ObjectCache.cacheObject([{ colId: 'studentName', sort: 'asc' }]);
  }

  private getStudentIdsByGradPlan(): string[] {
    const planIncompleteFilter: string = GraduationPlan.PLAN_INCOMPLETE.humanName;
    const planInPastFilter: string = GraduationPlan.PLAN_IN_PAST.humanName;
    return _.reduce(
      this.filteredStudents,
      (result, student: any) => {
        const { gradPlan, studentId } = student;
        const includeInFilter = gradPlan === planIncompleteFilter || gradPlan === planInPastFilter;
        if (includeInFilter) result.push(studentId);
        return result;
      },
      [],
    );
  }
}
